import {Group} from '@mantine/core';
import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

export interface ApplyButtonProps {
  disabled: boolean;
  onClick: () => void;
}

/**
 * Apply button component for plate map settings
 */
export default function ApplyButton({disabled, onClick}: ApplyButtonProps): JSX.Element {
  return (
    <Group ml="auto">
      <Button
        size={ButtonSize.SMALL}
        buttonStyle={ButtonStyle.PRIMARY}
        type="button"
        disabled={disabled}
        onClick={onClick}
      >
        Apply
      </Button>
    </Group>
  );
}
